import { useLanguage } from "../../../i18n/LanguageContext";

export default function SymptomModificationBlock({ block }) {
  const { language } = useLanguage();

  const c = block.content || {};
  const translated = block.translated_content || {};

  const getTranslation = (chineseValue, translatedValue) => {
    if (language === "zh") {
      return chineseValue || null;
    }

    if (language === "es" || language === "ru") {
      return translatedValue || null;
    }

    return null;
  };

  const symptomTranslation = getTranslation(
    c.symptom_zh,
    translated.symptom
  );

  const descriptionTranslation = getTranslation(
    c.description_zh,
    translated.description
  );

  const modificationTranslation = getTranslation(
    c.modification_zh,
    translated.modification
  );

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {/* Canonical English symptom */}
      <h3 style={{ margin: 0 }}>
        {c.symptom_en}
      </h3>

      {/* Selected-language symptom */}
      {symptomTranslation && (
        <div
          style={{
            color: "#6b7280",
            marginTop: "4px",
            marginBottom: "16px",
          }}
        >
          {symptomTranslation}
        </div>
      )}

      <div>
        <strong>Why It Happens</strong>

        {/* Canonical English */}
        {c.description_en && (
          <div
            style={{
              marginTop: "6px",
              lineHeight: "1.6",
            }}
          >
            {c.description_en}
          </div>
        )}

        {/* Selected-language learning aid */}
        {descriptionTranslation && (
          <div
            style={{
              marginTop: "5px",
              color: "#6b7280",
              lineHeight: "1.6",
            }}
          >
            {descriptionTranslation}
          </div>
        )}
      </div>

      <div
        style={{
          marginTop: "18px",
          paddingTop: "14px",
          borderTop: "1px solid #e5e7eb",
        }}
      >
        <strong>Massage Modification</strong>

        {/* Canonical English */}
        {c.modification_en && (
          <div
            style={{
              marginTop: "6px",
              lineHeight: "1.6",
            }}
          >
            {c.modification_en}
          </div>
        )}

        {/* Selected-language learning aid */}
        {modificationTranslation && (
          <div
            style={{
              marginTop: "5px",
              color: "#6b7280",
              lineHeight: "1.6",
            }}
          >
            {modificationTranslation}
          </div>
        )}
      </div>
    </div>
  );
}